<app-asset-tracking
    *ngIf="accessToken !== null"
    [clientId]="clientID"
    [facilityId]="facilityID"
    [accessToken]="accessToken"
    [assets]="assets"
    [geozones]="geozones"
    [showRoute]="returnRoute"
    [dateFrom]="date"
    [drivers]="drivers"
    [isSharedView]="true"
    [alarmFilters]="alarmFilters"
></app-asset-tracking>